import namespace from './namespace';
import AppService from './../../../service/app.js';

let appService = new AppService();
const ERROR_MESSAGE_TITLE = 'Operation failed';

export default {
	[namespace.actions.SEND_NOTIFICATION] ({ commit, state }, payload) {
		const listeners = state[namespace.state.NOTIFICATIONS_LISTENERS];
		if (listeners[payload.receiver] !== undefined) {			
			listeners[payload.receiver](payload.payload);
		}
		payload.dispatched = true;
		commit(namespace.mutations.ADD_NOTIFICATION, payload);
	},
	[namespace.actions.ADD_LISTENER] ({ commit, state }, payload) {
		commit(namespace.mutations.ASSIGN_LISTENER, payload);		
	},
    [namespace.actions.HANDLE_ERROR] ({ dispatch }, error) {  
        const message = appService.extractMessageFromErrorObject(error);
        dispatch(
            namespace.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox', 
                payload: {title: ERROR_MESSAGE_TITLE, message: message}
            }
        );
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js